module.exports = __webpack_public_path__ + "img/takaful.f665e3f8.png";